import { render } from "./MetaSettings.vue?vue&type=template&id=56725b1b&scoped=true"
import script from "./MetaSettings.vue?vue&type=script&lang=js"
export * from "./MetaSettings.vue?vue&type=script&lang=js"

import "./MetaSettings.vue?vue&type=style&index=0&id=56725b1b&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56725b1b"]])

export default __exports__